import Timetable from "../components/timetable";
import {UserRoles} from "../../helpers/userRoles";
import AddAction from "../components/addAction/addAction";
import ModifyAction from "../components/modifyAction/modifyAction";

export enum timetableRoutingAddress {
    week = "/timetable/week",
    addAction = "/timetable/add-action",
    modifyAction = "/timetable/modify-action"
}

export const timetableRoutes = [
    {
        path: timetableRoutingAddress.week,
        component: Timetable,
        roles: [UserRoles.timetableViewAndModification]
    }, {
        path: timetableRoutingAddress.addAction,
        component: AddAction,
        roles: [UserRoles.timetableViewAndModification]
    },
    {
        path: `${timetableRoutingAddress.modifyAction}/:id`,
        component: ModifyAction,
        roles: [UserRoles.timetableViewAndModification]
    },
];
